import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { landingFor } from '../constants/roles';

/** Index route ("/"): send an authenticated user to their role's landing page. */
export default function HomeRedirect() {
  const { user } = useAuth();
  return <Navigate to={user ? landingFor(user.role) : '/login'} replace />;
}
